import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AssetStatus } from '../AssetStatus';
import { TAssetStage } from '@brickwise/asset-validation/dist/schema/enums';

interface Props {
  open: boolean;
  handleClose: () => void;
}

export const StatusOverviewDialog: FC<Props> = ({ open, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Status info</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 1fr',
            gridTemplateRows: '1fr 1fr',
            rowGap: '10px',
            columnGap: '50px',
            padding: '10px',
          }}
        >
          <AssetStatus status={TAssetStage.preparing} />
          <div>{t('dashboard.assets.dialog.statusoverview.preparing')}</div>
          <AssetStatus status={TAssetStage.preorder} />
          <div>{t('dashboard.assets.dialog.statusoverview.preparing')}</div>
          <AssetStatus status={TAssetStage.review} />
          <div>{t('dashboard.assets.dialog.statusoverview.review')}</div>
          <AssetStatus status={TAssetStage.approved} />
          <div>{t('dashboard.assets.dialog.statusoverview.approved')}</div>
          <AssetStatus status={TAssetStage.declined} />
          <div>{t('dashboard.assets.dialog.statusoverview.declined')}</div>
          <AssetStatus status={TAssetStage.primary} />
          <div>{t('dashboard.assets.dialog.statusoverview.primary')}</div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={handleClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
